import { render, staticRenderFns } from "./publish-element-title.vue?vue&type=template&id=67ab9ae0"
import script from "./publish-element-title.vue?vue&type=script&lang=js"
export * from "./publish-element-title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports